"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.privateLoanFields = exports.businessLoanFields = void 0;
exports.businessLoanFields = `
  administrationFee
  creditCost
  documentFee
  effectiveInterest
  ignoreCampaigns
  invoiceFee
  loanAmount
  minimumAdministrationFee
  minimumNominalInterest
  nominalInterest
  subsidyCampaign
  totalCost
  totalMonthlyCost
`;
exports.privateLoanFields = `
  ${exports.businessLoanFields}
  monthlyDebtInsuranceCost
`;
//# sourceMappingURL=loan.js.map